import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { akitaDevtools } from '@datorama/akita';
import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';
import authProviders from './auth';
import categoryProviders from './category';
import { SDKConfig, SDK_CONFIG_TOKEN } from './config';
import eventProviders from './event';
import groupProviders from './group';
import messageProviders from './message';
import notificationProviders from './notification';
import requestProviders from './request';
import reviewProviders from './review';
import rootProviders from './root';
import userProviders from './user';

akitaDevtools();

@NgModule({
  declarations: [],
  imports: [HttpClientModule],
  exports: [],
  providers: [
    ...authProviders,
    ...categoryProviders,
    ...eventProviders,
    ...groupProviders,
    ...messageProviders,
    ...notificationProviders,
    ...requestProviders,
    ...reviewProviders,
    ...rootProviders,
    ...userProviders,
  ],
})
export class SdkModule {
  static forRoot(config: SDKConfig): ModuleWithProviders<SdkModule> {
    return {
      ngModule: SdkModule,
      providers: [
        ...authProviders,
        ...categoryProviders,
        ...eventProviders,
        ...groupProviders,
        ...messageProviders,
        ...notificationProviders,
        ...requestProviders,
        ...reviewProviders,
        ...rootProviders,
        ...userProviders,
        {
          provide: NG_ENTITY_SERVICE_CONFIG,
          useValue: {
            baseUrl: config.gatewayUrl,
          },
          deps: [SDK_CONFIG_TOKEN],
        },
        {
          provide: SDK_CONFIG_TOKEN,
          useValue: config,
        },
      ],
    };
  }
}
